export const AttachWalletMutation = `
mutation AttachWallet($signature: String!, $walletAddress: String!, $walletType: String!) {
  attachWallet(signature: $signature, walletAddress: $walletAddress, walletType: $walletType) {
    isSuccess
  }
}
`;
